import axios, {AxiosResponse} from 'axios'
import {
  DeactivationReason,
  DeactivationReasonQueryResponse,
  DeactivationReasonShort,
  ResponseObject,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const DEACTIVATION_REASON_URL = `${API_URL}/DeactivationReason`

const getAllData = (query: string): Promise<DeactivationReasonQueryResponse> => {
  return axios
    .get(`${DEACTIVATION_REASON_URL}?${query}`)
    .then((d: AxiosResponse<DeactivationReasonQueryResponse>) => d.data)
}

const getById = (code: number): Promise<DeactivationReason | undefined> => {
  return axios
    .get(`${DEACTIVATION_REASON_URL}/${code}`)
    .then((response: AxiosResponse<{data: DeactivationReason}>) => response.data.data)
}

const getActive = (): Promise<DeactivationReasonShort[]> => {
  return axios
    .get(`${DEACTIVATION_REASON_URL}/active`)
    .then((response: AxiosResponse<{data: DeactivationReasonShort[]}>) => response.data.data)
}

const createDataRecord = (data: DeactivationReason): Promise<ResponseObject | undefined> => {
  return axios
    .post(DEACTIVATION_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

const updateDataRecord = (data: DeactivationReason): Promise<ResponseObject | undefined> => {
  return axios
    .put(DEACTIVATION_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

export {getAllData, getById, getActive, createDataRecord, updateDataRecord}
